import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  console.log('AdminRoute: Checking access', { user: user?.email, role: user?.role, loading });

  if (loading) {
    console.log('AdminRoute: Still loading...');
    return <div>Loading...</div>; // Or a spinner
  }

  if (!user) {
    console.log('AdminRoute: No user, redirecting to login');
    // Not logged in, redirect to login
    return <Navigate to="/login" />;
  }

  if (user.role !== 'admin') {
    console.log('AdminRoute: User is not admin, redirecting to home');
    // Logged in but not an admin, redirect to a "not authorized" page or home
    return <Navigate to="/" />;
  }

  console.log('AdminRoute: Access granted, rendering admin content');
  // Logged in and is an admin, render the children
  return <>{children}</>;
};

export default AdminRoute; 